// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { newGuid } from "@insite/client-framework/Common/StringHelpers";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId, LinkModel } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkPresentationProps } from "@insite/mobius/Link";
import ArrowRight from "@steiner/XDL/Icons/ArrowRight";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

export const getMyAccountMapLinks = (state: ApplicationState, widgetLinks: LinkModel[]): PageLinkModel[] => {
    return (
        (widgetLinks
            ?.map(widgetLink => {
                if (widgetLink.fields.destination.type === "Url") {
                    return {
                        id: newGuid(),
                        title: widgetLink.fields.overriddenTitle || widgetLink.fields.destination.value,
                        url: widgetLink.fields.destination.value,
                        excludeFromNavigation: false,
                    } as PageLinkModel;
                }
                const pageLink = getPageLinkByNodeId(state, widgetLink.fields.destination.value);
                if (pageLink) {
                    return { ...pageLink, title: widgetLink.fields.overriddenTitle || pageLink?.title };
                }
                return undefined;
            })
            ?.filter(pageLink => !pageLink?.excludeFromNavigation) as PageLinkModel[]) || []
    );
};

export const backToLinkStyle: LinkPresentationProps = {
    icon: {
        iconProps: {
            size: 12,
            src: ArrowRight,
            color: "common.ui8",
            css: css`
                opacity: 0.66;
                rotate: 180deg;
            `,
        },
    },
    typographyProps: {
        size: 12,
        weight: fontConfig.weight.bold,
        transform: "initial",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
        `,
    },
};
